import React from 'react'

export default function index({ text }) {
    return (
        <section className="content-header">
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1>{text}</h1>
                    </div>
                </div>
            </div>{/* /.container-fluid */}
        </section>
    )
}
